import { create } from "zustand";

interface WaterfallAvailableStore {
  waterfallAvailable: boolean;
  setWaterfallAvailable: (waterfallAvailable: boolean) => void;
}

export const useWaterfallAvailableStore = create<WaterfallAvailableStore>()((set) => ({
  waterfallAvailable: false,
  setWaterfallAvailable: (waterfallAvailable: boolean) => set({ waterfallAvailable }),
}));
